import type { Story } from '@/store/story-types'

export const GROUP_BUYING_STORY: Story = {
  id: 'group-buying',
  name: 'TOGETHER — Group Deals',
  narrative: 'An influencer group buying platform where followers join collective deals with countdown timers, participant tracking, and volume-based discounts.',
  goals: ['Browse group deals', 'Join a group deal', 'Track participant count', 'Complete group purchase'],
  lifecycle: 'building',
  pages: [
    {
      id: 'pg-home', title: 'Home', order: 0, status: 'draft', elementCount: 4, linkedPageId: 'home',
      description: 'Landing page with hero banner and active deal grid',
      blockRef: { category: 'k-commerce', blockId: 'hero-banner' },
    },
    {
      id: 'pg-deal', title: 'Deal Detail', order: 1, status: 'draft', elementCount: 5, linkedPageId: 'deal',
      description: 'Deal detail page with countdown timer, participant list, and join button',
      blockRef: { category: 'k-commerce', blockId: 'deal-detail' },
    },
    {
      id: 'pg-cart', title: 'Cart', order: 2, status: 'draft', elementCount: 3, linkedPageId: 'cart',
      description: 'Cart and checkout with group discount applied',
      blockRef: { category: 'k-commerce', blockId: 'cart-checkout' },
    },
  ],
  bddScenarios: [
    {
      id: 'bdd-1',
      name: 'Browse Active Deals',
      description: 'Visitor browses currently active group deals',
      steps: [
        { type: 'given', text: 'the visitor is on the home page' },
        { type: 'when', text: 'the page loads' },
        { type: 'then', text: 'a deal grid with product images, prices, and countdown timers is visible', linkedPageId: 'home' },
      ],
    },
    {
      id: 'bdd-2',
      name: 'View Deal Detail',
      description: 'Visitor views a specific group deal with participant info',
      steps: [
        { type: 'given', text: 'the visitor taps a deal card' },
        { type: 'when', text: 'the deal detail page loads', linkedPageId: 'deal' },
        { type: 'then', text: 'product details, countdown timer, current participant count, and a join button are displayed' },
      ],
    },
    {
      id: 'bdd-3',
      name: 'Join Group Deal',
      description: 'Visitor joins a group deal and is added to participants',
      steps: [
        { type: 'given', text: 'the visitor is on the deal detail page', linkedPageId: 'deal' },
        { type: 'when', text: 'they tap the Join Deal button' },
        { type: 'then', text: 'the participant count increments and the item is added to cart', linkedPageId: 'cart' },
        { type: 'and', text: 'the group discount is reflected in the cart total', linkedFlowId: 'applyGroupDiscount' },
      ],
    },
    {
      id: 'bdd-4',
      name: 'Complete Group Purchase',
      description: 'Visitor completes checkout for a group deal',
      steps: [
        { type: 'given', text: 'the visitor has a group deal item in the cart', linkedPageId: 'cart' },
        { type: 'when', text: 'they proceed to checkout' },
        { type: 'then', text: 'the order summary shows the group discount and payment form is displayed' },
      ],
    },
    {
      id: 'bdd-5',
      name: 'Deal Expires',
      description: 'A deal countdown reaches zero before minimum participants',
      steps: [
        { type: 'given', text: 'the visitor is viewing a deal with low participation', linkedPageId: 'deal' },
        { type: 'when', text: 'the countdown timer reaches zero' },
        { type: 'then', text: 'the deal is marked as expired and the join button is disabled' },
      ],
    },
  ],
}
